import { formatBytes } from "~/lib/shared/formatBytes";
import { formatExtension } from "~/lib/shared/formatExtension";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import {
  FileUploadACFV1Payload,
  FileUploadACFV2Payload,
} from "~/types/asgard/FileUpload";
import {
  AssetDownloadEntryData,
  AssetDownloadProps,
} from "~/components/AssetDownload/AssetDownload";

type CommonProps = {
  assetSummary?: string;
  postId: number;
  postName: string;
};

export type ApiToAssetDownloadV1Props = CommonProps & {
  downloadableAssets: FileUploadACFV1Payload | undefined;
};

export type ApiToAssetDownloadV2Props = CommonProps & {
  downloadableAssets: FileUploadACFV2Payload | undefined;
};

export const apiToAssetDownloadV1Props = ({
  downloadableAssets,
  postId,
  postName,
  assetSummary,
}: ApiToAssetDownloadV1Props): AssetDownloadProps | null => {
  if (!downloadableAssets?.length) {
    return null;
  }

  return {
    postId,
    postName: heDecodeOrDefault(postName),
    assets: downloadableAssets.map<Omit<AssetDownloadEntryData, "postName">>(
      ({
        title,
        file_upload: { id, filesize, filename },
        file_description,
        permission,
      }) => ({
        attachmentId: id.toString(),
        attachmentTitle: heDecodeOrDefault(title),
        fileDescription: heDecodeOrDefault(file_description),
        fileSize: filesize > 0 ? formatBytes(filesize) : "—",
        permission,
        fileType: heDecodeOrDefault(formatExtension(filename)),
      })
    ),
    assetSummary: heDecodeOrDefault(assetSummary),
  };
};

export const apiToAssetDownloadV2Props = ({
  downloadableAssets,
  postId,
  postName,
  assetSummary,
}: ApiToAssetDownloadV2Props): AssetDownloadProps | null => {
  if (!downloadableAssets?.length) {
    return null;
  }

  return {
    postId,
    postName: heDecodeOrDefault(postName),
    assets: downloadableAssets.map<Omit<AssetDownloadEntryData, "postName">>(
      ({
        title,
        fileUpload: { id, filesize, filename },
        fileDescription,
        permission,
      }) => ({
        attachmentId: id.toString(),
        attachmentTitle: heDecodeOrDefault(title),
        fileDescription: heDecodeOrDefault(fileDescription),
        fileSize: filesize > 0 ? formatBytes(filesize) : "—",
        permission,
        fileType: heDecodeOrDefault(formatExtension(filename)),
      })
    ),
    assetSummary: heDecodeOrDefault(assetSummary),
  };
};
